import Vue from 'vue'
import Router from 'vue-router'
import headerComponent from '@/components/headerNew'
import login from '@/components/login'
import register from '@/components/register'
import footerComponent from '@/components/footerNew'
import homePage from '@/components/homePageNew'
import industryNews from '@/components/industryNews'
import industryTalk from '@/components/industryTalk'
import imgList from '@/components/imgList'
import tutorial from '@/components/tutorial'
import tutorialClass from '@/components/tutorialList/tutorialClass'
import software from '@/components/software'
import website from '@/components/website'
import contentPage from '@/components/contentPage'
import submission from '@/components/submission'
import userCenter from '@/components/userCenter'
import personFile from '@/components/userCenter/personFile'
import changePassword from '@/components/userCenter/changePassword'
import mySubmission from '@/components/userCenter/mySubmission'
import purchaseArticle from '@/components/userCenter/purchaseArticle'
import userHomepage from '@/components/userHomepage'
import contactUs from '@/components/contactUs'
import products from '@/components/products'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/',
      name: 'homePage',
      component: homePage
    },
    {
      path: '/header',
      name: 'headerComponent',
      component: headerComponent
    },
    {
      path: '/footer',
      name: 'footerComponent',
      component: footerComponent
    },
    {
      path: '/industryNews',
      name: 'industryNews',
      component: industryNews,
    },
    {
      path: '/industryTalk',
      name: 'industryTalk',
      component: industryTalk
    },
    {
      path: '/imgList',
      name: 'imgList',
      component: imgList
    },
    {
      path: '/tutorial',
      name: 'tutorial',
      component: tutorial,
    },
    {
      path:'/tutorialClass',
      name:'tutorialClass',
      component:tutorialClass
    },
    {
      path: '/software',
      name: 'software',
      component: software
    },
    {
      path: '/website',
      name: 'website',
      component: website
    },
    {
      path: '/contentPage/:id/',
      name: 'contentPage',
      component: contentPage,

    },
    {
      path: '/submission',
      name: 'submission',
      component: submission,

    },
    {
      path: '/userCenter',
      name: 'userCenter',
      component: userCenter,
      redirect: {name: 'personFile'},
      children: [  //这里就是二级路由的配置
        {
          path: '/personFile',
          name: 'personFile',
          component: personFile
        },
        {
          path: '/changePassword',
          name: 'changePassword',
          component: changePassword
        },
        {
          path: '/mySubmission',
          name: 'mySubmission',
          component: mySubmission
        },
        {
          path: '/purchaseArticle',
          name: 'purchaseArticle',
          component: purchaseArticle
        }
        ]
    },
    /*{
      path: '/personFile',
      name: 'personFile',
      component: personFile,
    },*/
    {
      path: '/userHomepage',
      name: 'userHomepage',
      component: userHomepage,
    },
    { path: '/contactUs',
      name: 'contactUs',
      component: contactUs,
    },
    { path: '/products',
      name: 'products',
      component: products,
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 1 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js